import { Card, CardBody } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ImRadioChecked } from "react-icons/im";
import { FaCircleCheck } from "react-icons/fa6";

function TrackingBar({ data, statusTrack }) {
    const { t } = useTranslation();    
  const trakingData = [
    {
      id: "0",
      status: "Prepare",
      city: data.StoreLocation,
      arrive: statusTrack === 'PENDING' || statusTrack === 'APPROVED' || statusTrack === 'ONAWAY' || statusTrack === 'ONLINE',
    },
    {
      id: "1",
      status: "On Away",
      city: "",
      arrive: statusTrack === 'ONAWAY' || statusTrack === 'ONLINE',
    },
    {
      id: "2",
      status: "End Point" ,
      city: data.UserAddress,
      arrive: statusTrack === 'ONLINE' ,
    },
  ];

    return (
        <Card className='card-custome border-0 rounded-24 my-4 tracking-bar-style'>
            <CardBody className='p-4 d-flex w-100 flex-wrap flex-lg-nowrap gap-1'>
                {trakingData.map((item, index) => {
                    return (
                        <div key={index} className={`flex-gap-2 time-line-style ${item.arrive && 'active'} before align-items-start flex-lg-column`}>
                            {item.arrive ? 
                                <FaCircleCheck size={25} color='#7FBA7A'/>                
                            :
                            <ImRadioChecked size={25} color='#d9d9d9'/>
                            // <div className='circle-border'>
                            //     <div className={`circle bg-grey`}></div>
                            // </div>

                }
                            <div className='time-line-content mt-1'>
                            <Card.Text className='mb-0 fw-semibold font-14'>{item.status}</Card.Text>
                                <Card.Text className='mb-2 subtitle font-12'>{t(item.city)} </Card.Text>
                            </div>

                        </div>
                    );
                })}
            </CardBody>
        </Card>
    );
};

export default TrackingBar;